define('app/factories/ga_product_impression_helper',['app/setup', 'app/views/ga_product_impression_helper'],
  function(takhfifan, gaProductImpressionHelper) {
    if($('.deal[data-details]').length){
      new takhfifan.gaProductImpressionHelper();
    }
  });

